import { ViewModelForm } from 'gw-portals-viewmodel-react';
import React, {
    useCallback,
    useContext
} from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { useModal,Link } from '@jutro/components';
import metadata from './ConditionsDetail_AX.metadata.json5';
import messages from './ConditionsDetail_AX.messages';
import styles from './ConditionsDetail_AX.module.scss';
import ConditionTextClaimDetailPopUp from '../ConditionTextClaimDetailPopUp_AX/ConditionTextClaimDetailPopUp';

function ConditionsDetailAX(props) {
    const {
        data
    } = props;
    const {
        showModal
        } = useModal();
    const translator = useContext(TranslatorContext);

    const popUpShowDescription = useCallback((event, description) => {
        event.preventDefault();

        const actionProps = {
            modalTitle: translator(messages.description),
            defaultButtonLabel: translator(messages.actionButton),
            description: description
        };
        showModal(
            <ConditionTextClaimDetailPopUp {...actionProps} />
        ).then(_.noop)
            .catch(_.noop);
    }, [translator]);

    const renderCellFn = useCallback((rowData) => {
        const description = _.get(rowData, 'description');
        if (description.length <= 50) {
            return !_.isUndefined(description) ? description : '';
        }
        const descriptionCut = description.substring(0, 50);
        const showMore = translator(messages.seeMore);
        return (
            <>
                <div>
                    {descriptionCut}
                    &nbsp;&nbsp;&nbsp;
                    <Link
                        href="/"
                        className={styles.documentNameLink}
                        onClick={(e) => popUpShowDescription(e, description)}
                    >
                        { showMore }
                    </Link>
                </div>
            </>
        );
    }, [popUpShowDescription, translator]);

    const overrides = {
        '@field': {
            labelPosition: 'left'
        },
        conditionsTable: {
            data: _.get(data, 'conditions')
        },
        descriptionCondition: {
            renderCell: renderCellFn
        },
    };

    return (
        <>
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={data}
                overrideProps={overrides}
            />
        </>
    );
}

export default withRouter(ConditionsDetailAX);
